/**
 * SMART BAZAR (smart-bazar.ro) - CORE JAVASCRIPT
 * Include: Animații la scroll (IntersectionObserver) + Modul Pop-up Checkout Express (COD)
 */

(function () {
  'use strict';

  // =========================================================================
  // 1. ANIMAȚII LA SCROLL (Native & Ultra-Rapide)
  // =========================================================================
  function initScrollReveals() {
    var revealElements = document.querySelectorAll('[data-warm-reveal]');
    if (!revealElements.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealElements.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    });

    revealElements.forEach(function (el) {
      observer.observe(el);
    });
  }

  // =========================================================================
  // 2. MODUL POP-UP CHECKOUT EXPRESS (COD / PLATĂ RAMBURS)
  // =========================================================================
  var JUDETE_ROMANIA = [
    'Alba', 'Arad', 'Argeș', 'Bacău', 'Bihor', 'Bistrița-Năsăud', 'Botoșani', 'Brașov', 
    'Brăila', 'București', 'Buzău', 'Caraș-Severin', 'Călărași', 'Cluj', 'Constanța', 
    'Covasna', 'Dâmbovița', 'Dolj', 'Galați', 'Giurgiu', 'Gorj', 'Harghita', 'Hunedoara', 
    'Ialomița', 'Iași', 'Ilfov', 'Maramureș', 'Mehedinți', 'Mureș', 'Neamț', 'Olt', 
    'Prahova', 'Satu Mare', 'Sălaj', 'Sibiu', 'Suceava', 'Teleorman', 'Timiș', 'Tulcea', 
    'Vaslui', 'Vâlcea', 'Vrancea'
  ];

  function populateCounties() {
    var selectEl = document.getElementById('sb-popup-county');
    if (!selectEl) return;
    
    // Evită popularea dublă
    if (selectEl.options.length > 1) return;

    JUDETE_ROMANIA.forEach(function (judet) {
      var opt = document.createElement('option');
      opt.value = judet;
      opt.textContent = judet;
      selectEl.appendChild(opt);
    });
  }

  // Helper: Calculează reducerea automată conformă cu regulile magazinului (2 prod = -10%, 3+ prod = -20%)
  window.calculateSmartAutoDiscount = function (totalQty, rawSubtotal) {
    var qty = parseInt(totalQty, 10) || 1;
    var raw = parseFloat(rawSubtotal) || 0;
    if (qty >= 3) {
      var amt20 = Math.round(raw * 0.20 * 100) / 100;
      return { amount: amt20, title: '3 produse = -20% automat', pct: 20 };
    }
    if (qty === 2) {
      var amt10 = Math.round(raw * 0.10 * 100) / 100;
      return { amount: amt10, title: '2 produse = -10% automat', pct: 10 };
    }
    return { amount: 0, title: null, pct: 0 };
  };

  window.updateCodSummaryUI = function (rawSubtotal, discountAmount, discountTitle, shippingFee, orderTotal) {
    var subtotalEl = document.getElementById('sb-summary-subtotal');
    if (subtotalEl) {
      subtotalEl.textContent = rawSubtotal.toFixed(2).replace('.', ',') + ' lei';
    }

    var discountRow = document.getElementById('sb-summary-discount-row');
    var discountLabel = document.getElementById('sb-summary-discount-label');
    var discountVal = document.getElementById('sb-summary-discount-value');
    if (discountRow) {
      if (discountAmount > 0) {
        discountRow.style.display = 'flex';
        if (discountLabel) {
          discountLabel.textContent = '🏷️ Reducere (' + (discountTitle || 'Automată') + '):';
        }
        if (discountVal) {
          discountVal.textContent = '-' + discountAmount.toFixed(2).replace('.', ',') + ' lei';
        }
      } else {
        discountRow.style.display = 'none';
      }
    }

    var isFreeShipping = shippingFee === 0;
    var shippingEl = document.getElementById('sb-summary-shipping');
    if (shippingEl) {
      if (isFreeShipping) {
        shippingEl.textContent = 'GRATUIT';
        shippingEl.style.color = '#16A34A';
      } else {
        shippingEl.textContent = shippingFee.toFixed(2).replace('.', ',') + ' lei';
        shippingEl.style.color = '#7935D2';
      }
    }

    var totalEl = document.getElementById('sb-summary-total');
    if (totalEl) {
      totalEl.textContent = orderTotal.toFixed(2).replace('.', ',') + ' lei';
    }

    var freeBadge = document.getElementById('sb-summary-free-badge');
    if (freeBadge) {
      freeBadge.style.display = isFreeShipping ? 'block' : 'none';
    }
  };

  // Funcție globală de deschidere a pop-up-ului
  window.openSmartCodPopup = function (data) {
    var backdrop = document.getElementById('sb-cod-popup');
    if (!backdrop) return;

    populateCounties();

    // Actualizează datele produsului în pop-up dacă sunt trimise
    if (data) {
      if (data.title) {
        var titleEl = document.getElementById('sb-popup-title');
        if (titleEl) titleEl.textContent = data.title;
      }
      if (data.price) {
        var priceEl = document.getElementById('sb-popup-price');
        if (priceEl) priceEl.textContent = data.price;
        var btnPriceEl = document.getElementById('sb-popup-btn-price');
        if (btnPriceEl) btnPriceEl.textContent = data.price;
      }
      if (data.image) {
        var imgEl = document.getElementById('sb-popup-img');
        if (imgEl) imgEl.src = data.image;
      }
      var qtyBadge = document.getElementById('sb-popup-qty-badge');
      if (qtyBadge) {
        qtyBadge.textContent = (data.quantity || 1) + ' buc.';
      }
      var numericPrice = 149.99;
      if (data.price) {
        var pMatch = String(data.price).replace(',', '.').match(/[\d.]+/);
        if (pMatch) numericPrice = parseFloat(pMatch[0]);
      }
      var qty = parseInt(data.quantity, 10) || 1;
      var rawSubtotal = Math.round(numericPrice * qty * 100) / 100;
      var disc = window.calculateSmartAutoDiscount(qty, rawSubtotal);
      var discountedSubtotal = Math.max(0, Math.round((rawSubtotal - disc.amount) * 100) / 100);
      var isFreeShipping = discountedSubtotal >= 200;
      var shippingFee = isFreeShipping ? 0 : 20.00;
      var orderTotal = Math.round((discountedSubtotal + shippingFee) * 100) / 100;

      window.updateCodSummaryUI(rawSubtotal, disc.amount, disc.title, shippingFee, orderTotal);

      var formEl = document.getElementById('sb-cod-form');
      if (formEl) {
        formEl.setAttribute('data-variant-id', data.variant_id || '');
        formEl.setAttribute('data-quantity', qty);
        formEl.setAttribute('data-raw-subtotal', rawSubtotal.toFixed(2));
        formEl.setAttribute('data-discount-amount', disc.amount.toFixed(2));
        formEl.setAttribute('data-discount-title', disc.title || '');
        formEl.setAttribute('data-subtotal', discountedSubtotal.toFixed(2));
        formEl.setAttribute('data-shipping', shippingFee.toFixed(2));
        formEl.setAttribute('data-total', orderTotal.toFixed(2));
      }
    }

    var singleProdWrap = document.getElementById('sb-popup-single-product');
    if (singleProdWrap) singleProdWrap.style.display = 'flex';
    var cartProdsWrap = document.getElementById('sb-popup-cart-products');
    if (cartProdsWrap) cartProdsWrap.style.display = 'none';
    var formEl = document.getElementById('sb-cod-form');
    if (formEl) formEl.setAttribute('data-cart-mode', 'false');
    window._sbCartPayload = null;

    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden'; // Blochează scroll-ul de fundal
  };

  // Funcție globală de deschidere a pop-up-ului pentru ÎNTREG COȘUL (Checkout 1-Click din Coș)
  window.openSmartCodCartPopup = function () {
    var backdrop = document.getElementById('sb-cod-popup');
    if (!backdrop) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) {
          alert('Coșul tău este gol! Adaugă produse în coș pentru a plasa comanda.');
          return;
        }

        populateCounties();

        var singleProdWrap = document.getElementById('sb-popup-single-product');
        if (singleProdWrap) singleProdWrap.style.display = 'none';

        var cartProdsWrap = document.getElementById('sb-popup-cart-products');
        if (cartProdsWrap) cartProdsWrap.style.display = 'block';

        var badgeCount = document.getElementById('sb-popup-cart-count-badge');
        if (badgeCount) {
          badgeCount.textContent = cart.item_count + (cart.item_count === 1 ? ' produs' : ' produse');
        }

        var itemsListEl = document.getElementById('sb-popup-cart-items-list');
        var itemsHtml = '';
        var itemsPayload = [];
        var rawSubtotal = 0;

        cart.items.forEach(function (item) {
          var origCents = (typeof item.original_price === 'number') ? item.original_price : item.price;
          var itOrigPrice = (origCents / 100).toFixed(2);
          var itOrigFormatted = itOrigPrice.replace('.', ',') + ' lei';
          var itImg = item.featured_image ? (item.featured_image.url || item.image) : (item.image || '');
          rawSubtotal += (origCents / 100) * item.quantity;

          itemsHtml += `
            <div style="display:flex; align-items:center; justify-content:space-between; gap:10px; padding:6px 0; border-bottom:1px solid #EADBFA;">
              <div style="display:flex; align-items:center; gap:8px; overflow:hidden;">
                ${itImg ? `<img src="${itImg}" style="width:38px; height:38px; object-fit:cover; border-radius:6px; flex-shrink:0; border:1px solid #E5E7EB;">` : ''}
                <div style="font-size:1.2rem; font-weight:600; color:#1F2937; line-height:1.3; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:180px;">
                  ${item.title}
                </div>
              </div>
              <div style="text-align:right; flex-shrink:0; font-size:1.2rem;">
                <span style="font-weight:700; color:#7935D2;">${item.quantity} buc.</span>
                <span style="color:#6B7280; margin-left:4px;">× ${itOrigFormatted}</span>
              </div>
            </div>
          `;

          itemsPayload.push({
            title: item.title,
            price: itOrigPrice,
            original_price: itOrigPrice,
            quantity: item.quantity,
            variant_id: item.variant_id || item.id,
            image: itImg
          });
        });

        if (itemsListEl) itemsListEl.innerHTML = itemsHtml;

        rawSubtotal = Math.round(rawSubtotal * 100) / 100;
        var disc = window.calculateSmartAutoDiscount(cart.item_count, rawSubtotal);
        // Dacă Shopify Cart a aplicat deja o reducere automată, o folosim pe cea mai mare / exactă
        var shopifyCartDiscount = (typeof cart.total_discount === 'number') ? (cart.total_discount / 100) : 0;
        var finalDiscountAmount = shopifyCartDiscount > 0 ? shopifyCartDiscount : disc.amount;
        var finalDiscountTitle = disc.title || 'Reducere automată';
        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0 && cart.cart_level_discount_applications[0].title) {
          finalDiscountTitle = cart.cart_level_discount_applications[0].title;
        }

        var discountedSubtotal = Math.max(0, Math.round((rawSubtotal - finalDiscountAmount) * 100) / 100);
        var isFreeShipping = discountedSubtotal >= 200;
        var shippingFee = isFreeShipping ? 0 : 20.00;
        var orderTotal = Math.round((discountedSubtotal + shippingFee) * 100) / 100;

        window.updateCodSummaryUI(rawSubtotal, finalDiscountAmount, finalDiscountTitle, shippingFee, orderTotal);

        var formEl = document.getElementById('sb-cod-form');
        if (formEl) {
          formEl.setAttribute('data-cart-mode', 'true');
          formEl.setAttribute('data-raw-subtotal', rawSubtotal.toFixed(2));
          formEl.setAttribute('data-discount-amount', finalDiscountAmount.toFixed(2));
          formEl.setAttribute('data-discount-title', finalDiscountTitle || '');
          formEl.setAttribute('data-subtotal', discountedSubtotal.toFixed(2));
          formEl.setAttribute('data-shipping', shippingFee.toFixed(2));
          formEl.setAttribute('data-total', orderTotal.toFixed(2));
        }

        window._sbCartPayload = itemsPayload;

        backdrop.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      })
      .catch(function (err) {
        console.error('Eroare încărcare coș:', err);
        window.location.href = '/checkout';
      });
  };

  // Funcție globală de închidere
  window.closeSmartCodPopup = function () {
    var backdrop = document.getElementById('sb-cod-popup');
    if (!backdrop) return;
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  function initCodPopupEvents() {
    var backdrop = document.getElementById('sb-cod-popup');
    if (!backdrop) return;

    // Închidere la click pe X
    var closeBtn = document.getElementById('sb-popup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', window.closeSmartCodPopup);
    }

    // Închidere la click pe fundalul gri
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) {
        window.closeSmartCodPopup();
      }
    });

    // Închidere la tasta Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        window.closeSmartCodPopup();
      }
    });

    // Triggere automate pentru butoane din pagină cu atributul [data-sb-cod-trigger]
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-sb-cod-trigger]');
      if (!trigger) return;
      e.preventDefault();

      var qtyInput = document.querySelector('input[name="quantity"]') || document.querySelector('.quantity__input');
      var currentQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      var productData = {
        title: trigger.getAttribute('data-product-title') || document.querySelector('.product__title h1')?.textContent?.trim() || 'Produs Smart Bazar',
        price: trigger.getAttribute('data-product-price') || document.querySelector('.price-item--sale, .price-item--regular')?.textContent?.trim() || '149,99 lei',
        image: trigger.getAttribute('data-product-image') || document.querySelector('.product__media img')?.src || '',
        variant_id: trigger.getAttribute('data-variant-id') || document.querySelector('input[name="id"]')?.value || '',
        product_id: trigger.getAttribute('data-product-id') || '',
        quantity: currentQty
      };

      window.openSmartCodPopup(productData);
    });

    // Trimiterea formularului COD
    var form = document.getElementById('sb-cod-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var phoneInput = document.getElementById('sb-popup-phone');
        var phone = phoneInput ? phoneInput.value.replace(/\s+/g, '') : '';
        
        // Validare număr telefon România (07...)
        var phoneRegex = /^07[0-9]{8}$/;
        if (!phoneRegex.test(phone)) {
          alert('Te rugăm să introduci un număr de telefon valid din România (ex: 0722123456).');
          if (phoneInput) phoneInput.focus();
          return;
        }

        var submitBtn = form.querySelector('.sb-submit-btn');
        var originalBtnHtml = submitBtn ? submitBtn.innerHTML : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerHTML = '<span>Se transmite comanda către depozit...</span>';
        }

        // Preluare date comandă
        var isCartMode = form.getAttribute('data-cart-mode') === 'true';
        var formRawSubtotal = form.getAttribute('data-raw-subtotal') || form.getAttribute('data-subtotal') || '149.99';
        var formDiscountAmount = form.getAttribute('data-discount-amount') || '0.00';
        var formDiscountTitle = form.getAttribute('data-discount-title') || '';
        var formSubtotal = form.getAttribute('data-subtotal') || '149.99';
        var formShipping = form.getAttribute('data-shipping') || '20.00';
        var formTotal = form.getAttribute('data-total') || '169.99';

        var orderData = {
          name: document.getElementById('sb-popup-name')?.value?.trim(),
          phone: phone,
          county: document.getElementById('sb-popup-county')?.value,
          city: document.getElementById('sb-popup-city')?.value?.trim(),
          address: document.getElementById('sb-popup-address')?.value?.trim(),
          product_title: isCartMode ? 'Comandă Coș Produse Smart Bazar' : (document.getElementById('sb-popup-title')?.textContent || 'Produs Smart Bazar'),
          price: document.getElementById('sb-popup-price')?.textContent || '149,99 lei',
          raw_subtotal: formRawSubtotal,
          discount_amount: formDiscountAmount,
          discount_title: formDiscountTitle,
          subtotal: formSubtotal,
          shipping: formShipping,
          total_price: formTotal,
          items: isCartMode ? (window._sbCartPayload || []) : null,
          variant_id: form.getAttribute('data-variant-id') || document.querySelector('[data-sb-cod-trigger]')?.getAttribute('data-variant-id') || '',
          quantity: parseInt(form.getAttribute('data-quantity'), 10) || 1,
          payment: 'Ramburs (Plată la curier)'
        };

        function renderSuccessScreen(data, orderNum, respData) {
          var body = document.querySelector('.sb-popup-body');
          if (!body) return;
          var finalTotalStr = (respData && respData.total_price) ? String(respData.total_price) : (data.total_price || data.price || '--');
          var finalSubtotalStr = (respData && respData.subtotal) ? String(respData.subtotal) : (data.subtotal || data.price || '--');
          var finalShippingStr = (respData && respData.shipping !== undefined) ? String(respData.shipping) : (data.shipping || '20.00');
          var finalDiscAmt = parseFloat((respData && respData.discount_amount !== undefined) ? respData.discount_amount : (data.discount_amount || '0')) || 0;
          var finalDiscTitle = (respData && respData.discount_title) ? respData.discount_title : (data.discount_title || 'Reducere automată');

          var displayTotal = finalTotalStr.replace('.', ',');
          var displaySubtotal = finalSubtotalStr.replace('.', ',');
          var shippingText = parseFloat(finalShippingStr) === 0 ? 'GRATUIT' : (finalShippingStr.replace('.', ',') + ' lei');
          var discountLineHtml = finalDiscAmt > 0
            ? `<div style="font-size: 1.25rem; color: #16A34A; font-weight: 700; margin-bottom: 4px;">🏷️ Reducere aplicată (${finalDiscTitle}): -${finalDiscAmt.toFixed(2).replace('.', ',')} lei</div>`
            : '';

          body.innerHTML = `
            <div style="text-align: center; padding: 26px 12px;">
              <div style="width: 68px; height: 68px; background: #EBF7EE; color: #2B7A4C; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; font-size: 34px; margin-bottom: 16px; box-shadow: 0 8px 20px -6px rgba(34, 123, 79, 0.35);">
                ✓
              </div>
              <div style="display: inline-block; background: #F3E8FF; color: #7935D2; font-weight: 800; font-size: 1.25rem; padding: 4px 14px; border-radius: 999px; margin-bottom: 12px; border: 1px solid #EADBFA;">
                Comandă confirmată oficial: ${orderNum}
              </div>
              <h3 style="font-family: var(--sb-font-heading); font-size: 2.2rem; color: #191424; margin: 0 0 10px;">Felicitări, ${data.name}!</h3>
              <p style="font-size: 1.45rem; color: #191424; line-height: 1.5; margin: 0 0 18px;">
                Comanda ta pentru <strong>${data.product_title}</strong> a fost înregistrată în sistem și transmisă direct către depozit!
              </p>
              <div style="background: #FAF5FF; border: 1.5px solid #EADBFA; border-radius: 12px; padding: 16px; font-size: 1.35rem; margin-bottom: 22px; text-align: left; line-height: 1.6;">
                <div style="margin-bottom: 6px;">📦 <strong>Livrare:</strong> 24–48h la adresa <em>${data.address}, ${data.city}, Jud. ${data.county}</em></div>
                <div style="margin-bottom: 4px;">💰 <strong>De plată la curier:</strong> <strong style="color: #7935D2; font-size: 1.6rem;">${displayTotal} lei</strong> (Numerar / Ramburs)</div>
                ${discountLineHtml}
                <div style="font-size: 1.2rem; color: #4B5563; margin-bottom: 8px;">↳ Produse (după reducere): ${displaySubtotal} lei | Transport Curier: <strong style="color:${parseFloat(finalShippingStr) === 0 ? '#16A34A' : '#7935D2'};">${shippingText}</strong></div>
                <div style="margin-bottom: 6px;">📞 <strong>Telefon:</strong> ${data.phone}</div>
                <div>💬 <strong>Confirmare:</strong> Comanda ta este procesată cu prioritate</div>
              </div>
              <button type="button" class="button" style="width: 100%; min-height: 50px; font-size: 1.5rem;" onclick="window.closeSmartCodPopup(); location.reload();">
                Continuă cumpărăturile pe Smart-Bazar.ro
              </button>
            </div>
          `;
        }

        // Endpoint dedicat backend (Cloudflare Worker -> Shopify Orders API)
        var endpoint = window.SB_ORDER_ENDPOINT || 'https://wild-scene-ec5a.bsnsgroupinternationalllcfz.workers.dev/';

        fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(orderData)
        })
        .then(function (res) {
          return res.json().then(function (json) {
            if (!res.ok) {
              var errMsg = json?.error || ('Serverul a răspuns cu cod: ' + res.status);
              if (json?.details?.errors) {
                errMsg += ' (' + JSON.stringify(json.details.errors) + ')';
              }
              throw new Error(errMsg);
            }
            return json;
          });
        })
        .then(function (respData) {
          if (respData && respData.success && respData.order_number) {
            // Dacă s-a comandat din coș, golim coșul Shopify
            if (isCartMode) {
              fetch('/cart/clear.js', { method: 'POST' })
                .then(function () {
                  document.querySelectorAll('.cart-count-bubble span').forEach(function (s) { s.textContent = '0'; });
                  var bubbles = document.querySelectorAll('.cart-count-bubble');
                  bubbles.forEach(function (b) { b.classList.add('hidden'); });
                  if (typeof window.updateWarmShipBar === 'function') window.updateWarmShipBar({ total_price: 0 });
                })
                .catch(function (e) { console.warn('Could not clear cart:', e); });
            }
            renderSuccessScreen(orderData, respData.order_number, respData);
          } else {
            throw new Error(respData?.error || 'Răspuns nevalid');
          }
        })
        .catch(function (err) {
          console.error('Eroare trimitere comandă:', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalBtnHtml;
          }
          alert('Nu s-a putut trimite comanda automat în acest moment (' + err.message + '). Te rugăm să ne scrii la suport@smart-bazar.ro sau să folosești butonul „Adaugă în coș”!');
        });
      });
    }

    // Interceptare automată a butoanelor de Checkout din Coș (Cart Drawer și pagina /cart)
    document.addEventListener('click', function (e) {
      var checkoutBtn = e.target.closest('button[name="checkout"], #CartDrawer-Checkout, #checkout, .cart__checkout-button, a[href="/checkout"], a[href^="/checkout?"]');
      if (!checkoutBtn) return;
      if (checkoutBtn.closest('#sb-cod-popup')) return;

      e.preventDefault();
      e.stopPropagation();

      // Închide cart drawer dacă este deschis
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.close === 'function') {
        drawer.close();
      } else {
        var activeDrawer = document.querySelector('cart-drawer.active');
        if (activeDrawer) activeDrawer.classList.remove('active');
      }

      window.openSmartCodCartPopup();
    }, true);
  }

  // =========================================================================
  // 3. ACTUALIZARE DINAMICĂ BARA DE TRANSPORT GRATUIT (warm-shipbar)
  // =========================================================================
  window.updateWarmShipBar = function (cart) {
    var shipbars = document.querySelectorAll('[data-warm-shipbar]');
    if (!shipbars.length) return;

    var total = (cart && typeof cart.total_price === 'number') ? cart.total_price : 0;
    var threshold = 20000; // 200.00 RON
    var isFree = total >= threshold;
    var remaining = Math.max(0, threshold - total);
    var percent = Math.min(100, Math.max(0, Math.round((total / threshold) * 100)));
    if (percent < 4 && total > 0) percent = 4;

    shipbars.forEach(function (bar) {
      bar.classList.toggle('is-free', isFree);
      var fill = bar.querySelector('[data-fill]');
      if (fill) fill.style.width = percent + '%';

      var msg = bar.querySelector('.sb-shipbar__message');
      if (msg) {
        if (isFree) {
          msg.innerHTML = '<div class="sb-shipbar__msg-free"><span class="sb-shipbar__icon">🎉</span><span>Felicitări! Ai obținut <strong>Transport GRATUIT!</strong></span></div>';
        } else {
          var remLei = (remaining / 100).toFixed(2).replace('.', ',') + ' lei';
          msg.innerHTML = '<div class="sb-shipbar__msg-add"><span class="sb-shipbar__icon">🚚</span><span>Mai adaugă <strong class="sb-shipbar__remaining">' + remLei + '</strong> pentru <strong>Transport Gratuit!</strong></span></div>';
        }
      }
    });
  };

  // =========================================================================
  // 4. CRONOMETRU DINAMIC EXPEDIERE RAPIDĂ (DISPATCH COUNTDOWN)
  // =========================================================================
  function initDispatchCountdown() {
    var clockEl = document.getElementById('sb-dispatch-clock');
    var arrivalEl = document.getElementById('sb-dispatch-arrival');
    if (!clockEl && !arrivalEl) return;

    var ZILE_SAPTAMANA = ['Duminică', 'Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'];
    var LUNI_AN = ['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'];

    function updateTimer() {
      var now = new Date();
      var currentHour = now.getHours();
      var currentDay = now.getDay();

      var cutoffHour = 16;
      var isSameDay = currentHour < cutoffHour && currentDay !== 0 && currentDay !== 6;

      var targetDate = new Date(now);
      if (isSameDay) {
        targetDate.setHours(cutoffHour, 0, 0, 0);
      } else {
        if (currentDay === 5 && currentHour >= cutoffHour) {
          targetDate.setDate(now.getDate() + 3);
        } else if (currentDay === 6) {
          targetDate.setDate(now.getDate() + 2);
        } else if (currentDay === 0) {
          targetDate.setDate(now.getDate() + 1);
        } else {
          targetDate.setDate(now.getDate() + 1);
        }
        targetDate.setHours(cutoffHour, 0, 0, 0);
      }

      var diffMs = targetDate.getTime() - now.getTime();
      if (diffMs < 0) diffMs = 0;

      var hours = Math.floor(diffMs / (1000 * 60 * 60));
      var mins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      var secs = Math.floor((diffMs % (1000 * 60)) / 1000);

      var pad = function (n) { return n < 10 ? '0' + n : n; };

      if (clockEl) {
        clockEl.textContent = pad(hours) + 'h : ' + pad(mins) + 'm : ' + pad(secs) + 's';
      }

      if (arrivalEl) {
        var deliveryDate = new Date(now);
        var addDays = isSameDay ? 1 : 2;
        deliveryDate.setDate(now.getDate() + addDays);

        if (deliveryDate.getDay() === 0) {
          deliveryDate.setDate(deliveryDate.getDate() + 1);
        }

        var ziText = ZILE_SAPTAMANA[deliveryDate.getDay()];
        var dataNum = deliveryDate.getDate();
        var lunaText = LUNI_AN[deliveryDate.getMonth()];

        var label = (addDays === 1) ? 'Mâine (' + ziText + ', ' + dataNum + ' ' + lunaText + ')' : ziText + ', ' + dataNum + ' ' + lunaText;
        arrivalEl.textContent = label;
      }
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  }

  // =========================================================================
  // INITIALIZARE
  // =========================================================================
  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveals();
    initCodPopupEvents();
    initDispatchCountdown();
  });

})();
